import Alert, { AlertProps } from './Alert';

export type { AlertProps };
export default Alert;
